module.exports = __webpack_public_path__ + "img/safety-icon-1.039eb903.png";